document.addEventListener("DOMContentLoaded", () => {
  const supabaseUrl = "https://yoknilkbfolymbqeegqz.supabase.co"; 
  const supabaseKey = "sb_publishable_HiQUj1Avvjl5fomUzC2Ltw_dstmAO-4";
  
  // This replaces 'const supabase = ...' and makes it accessible everywhere
  window.supabaseClient = window.supabase.createClient(supabaseUrl, supabaseKey);
  
  console.log("Supabase successfully initialized!");
});

  const WOOD_STATE = {
  historyStack: [],
  cachedColorCount: 0,
  currentTextTier: "medium"
};

window.WOOD_STATE = WOOD_STATE;




  function initCustomizer() {

  const customizerRoot =
    document.getElementById("wood-customizer-root");

  if (!customizerRoot) {
    console.log(
      "Wood customizer not present. Skipping."
    );
    return;
  }

  const shopifyBtn =
    document.querySelector('.product-form__submit');

  if (shopifyBtn) {
    shopifyBtn.style.display = "none";
  }

    /* =========================
       ELEMENT CACHE
    ========================= */

    const els = {
        
      
      preview: document.getElementById("preview"),
      addonLayer: document.getElementById("addonLayer"),

      textInput: document.getElementById("customTextInput"),
      previewText: document.getElementById("liveTextPreview"),
      textSizeSlider: document.getElementById("textSizeSlider"),
      textColorPicker: document.getElementById("textColorPicker"),
      addTextLayerBtn: document.getElementById("addTextLayer"),

      sizeSelector: document.getElementById("sizeSelector"),
      woodType: document.getElementById("woodType"),
      layerSelector: document.getElementById("layerSelector"),
      shapeSelector: document.getElementById("shapeSelector"),

      textStyle: document.getElementById("textStyle"),
      stainSelector: document.getElementById("stainSelector"),
      detailToggle: document.getElementById("detailToggle"),

      uploader: document.getElementById("imageUploader"),
      liveImage: document.getElementById("liveImagePreview"),
      imageWrapper: document.getElementById("imageWrapper"),
      imageSizeSlider:
      document.getElementById("imageSizeSlider"),

      imageSizeContainer:
      document.getElementById("imageSizeContainer"),

      rushOrder: document.getElementById("rushOrder"),

      basePriceEl: document.getElementById("basePrice"),
      woodCostEl: document.getElementById("woodCost"),
      layerCostEl: document.getElementById("layerCost"),
      stainCostEl: document.getElementById("stainCost"),
      textCostEl: document.getElementById("textCost"),
      totalEl: document.getElementById("liveTotal"),
      rushCostEl: document.getElementById("rushCost"),

      colorCostEl: document.getElementById("colorCost"),
      detailCostEl: document.getElementById("detailCost"),
      textStyleCostEl: document.getElementById("textStyleCost"),

      colorInfoBox: document.getElementById("colorInfoBox"),
      colorPalette: document.getElementById("colorPalette"),
      colorScale: document.getElementById("colorScale"),
      scaleFill: document.getElementById("scaleFill"),
      colorSuggestion: document.getElementById("colorSuggestion"),

      colorCountText: document.getElementById("colorCountText"),
      colorPriceText: document.getElementById("colorPriceText"),
      colorComplexityText: document.getElementById("colorComplexityText"),

      builderError: document.getElementById("builderError"),

      liveSize: document.getElementById("liveSize"),
      liveShape: document.getElementById("liveShape"),
      liveWood: document.getElementById("liveWood"),

      exportBtn: document.getElementById("exportDesign"),

      baseWoodImage: document.getElementById("baseWoodImage"),

      

      saveBtn: document.getElementById("saveDesignBtn"),
      loadBtn: document.getElementById("loadDesignBtn"),
      deleteBtn: document.getElementById("deleteImageBtn"),
      undoBtn: document.getElementById("undoBtn"),
      draggableText: document.querySelector(".draggable-text"),

      form: document.querySelector('form[action*="/cart/add"]')
    };

window.els = els;

/* =========================
   IMAGE SIZE SLIDER
========================= */

if (els.imageSizeSlider) {

  els.imageSizeSlider.addEventListener(
    "input",
    function () {

      if (!els.liveImage) return;

      els.liveImage.style.width =
        this.value + "px";

      window.WOODPricing?.updatePrice?.();

      window.WOODStorage?.save?.();

    }
  );

}

if (!els.preview) return;
    const debouncedSave =
  debounce(() => {
    window.WOODStorage?.save();
  }, 300);

    function debounce(fn, delay) {
  let timeout;
  

  return function (...args) {
    clearTimeout(timeout);

    timeout = setTimeout(() => {
      fn.apply(this, args);
    }, delay);
  };
}

    

    

    /* =========================
       TEXT INPUT
    ========================= */

    if (els.textInput && els.previewText) {

  els.previewText.style.display = "block";
  els.previewText.style.zIndex = "20";

  els.textInput.addEventListener("input", function () {

    const text = this.value.trim();

    els.previewText.textContent =
      text || "Your Text";

    

    const charCountEl =
      document.querySelector(".char-count");

    if (charCountEl) {
      charCountEl.textContent =
        text.length + " / 20";
    }

    updateTextStyle();

    

    debouncedSave();
  });
}

    

    /* =========================
   IMAGE UPLOAD
========================= */

if (els.uploader) {

  els.uploader.addEventListener("change", function () {

    const file = this.files?.[0];

    if (!file) return;

    const allowed = [
      "image/png",
      "image/jpeg",
      "image/webp"
    ];

    if (!allowed.includes(file.type)) {

      alert("Unsupported image type");
      return;
    }

    const reader = new FileReader();

    reader.onload = (e) => {

      if (!e.target?.result) return;

      els.liveImage.crossOrigin = "anonymous";

      els.liveImage.onload = null;

      els.liveImage.onload = async () => {

        await new Promise(resolve =>
          requestAnimationFrame(resolve)
        );

        if (
          !els.liveImage.naturalWidth ||
          !els.liveImage.naturalHeight
        ) {

          console.warn("Image dimensions missing");
          return;
        }

        WOOD_STATE.cachedColorCount =
          getImageColorCount(els.liveImage);

        console.log(
          "Detected Colors:",
          WOOD_STATE.cachedColorCount
        );

        if (els.imageWrapper) {

          els.imageWrapper.style.display = "block";
          els.imageWrapper.style.zIndex = "25";
        }
        if (els.imageSizeContainer) {

        els.imageSizeContainer.style.display =
        "block";

        }

        els.liveImage.style.display = "block";

        if (window.WOOD_DRAG?.enable) {

  window.WOOD_DRAG.enable(
    els.imageWrapper,
    els.preview
  );

  els.imageWrapper.dataset.dragEnabled = "true";

}
if (
  els.imageWrapper &&
  window.WOOD_DRAG?.enable
) {

  window.WOOD_DRAG.enable(
    els.imageWrapper,
    els.preview
  );

}

        updateColorUI();

        renderColorPalette(els.liveImage);

        window.WOODPricing?.updatePrice();

        debouncedSave();
      };

      els.liveImage.src = e.target.result;
els.liveImage.style.background = "transparent";

if (els.imageSizeSlider) {
  els.imageSizeSlider.value = 150;
}
    };

    reader.readAsDataURL(file);
  });
}

    
    
function attachTextLayerEvents(el) {

  if (el.dataset.eventsAttached === "true") return;

  el.dataset.eventsAttached = "true";

  el.addEventListener("click", function(e) {

    e.stopPropagation();

    selectTextLayer(el);

  });

  el.addEventListener("dblclick", function() {

    el.contentEditable = "true";

    el.focus();

  });

  el.addEventListener("blur", function() {

    el.contentEditable = "false";

    debouncedSave();

  });

  el.addEventListener("input", debouncedSave);

  el.addEventListener("paste", function(e) {

  e.preventDefault();

  const text =
    (e.clipboardData || window.clipboardData)
    .getData("text");

  const selection = window.getSelection();

  if (!selection.rangeCount) return;

  selection.getRangeAt(0).insertNode(
    document.createTextNode(text)
  );
});

}
window.attachTextLayerEvents =
  attachTextLayerEvents;
/* =========================
   ADD ANOTHER TEXT
========================= */

if (els.addTextLayerBtn) {

  els.addTextLayerBtn.addEventListener(
    "click",
    function () {

      const newText = document.createElement("div");

      newText.className = "draggable-text";
      newText.dataset.extra = "true";

      newText.contentEditable = "false";

      newText.textContent = "New Text";

      newText.style.position = "absolute";
      newText.style.top = "120px";
      newText.style.left = "120px";

      newText.style.fontSize =
        (els.textSizeSlider?.value || 28) + "px";

      newText.style.color =
        els.textColorPicker?.value || "#000";

      newText.style.fontFamily =
        els.previewText?.style.fontFamily || "serif";

      newText.style.cursor = "move";
      newText.style.zIndex = "20";
      newText.style.minWidth = "40px";

      if (!els.addonLayer) return;
      els.addonLayer.appendChild(newText);

      attachTextLayerEvents(newText);

      selectTextLayer(newText);

      if (window.WOOD_DRAG?.enable) {

        window.WOOD_DRAG.enable(
          newText,
          els.preview
        );

      }

      debouncedSave();

    }
  );
}

      


if (els.saveBtn) {
  els.saveBtn.addEventListener(
    "click",
    () => window.WOODStorage?.save()
  );
}

if (els.loadBtn) {
  els.loadBtn.addEventListener(
    "click",
    () => window.WOODStorage?.load()
  );
}

if (els.undoBtn) {
  els.undoBtn.addEventListener(
    "click",
    () => window.WOODStorage?.undo()
  );
}
if (els.exportBtn) {

  els.exportBtn.addEventListener("click", async function () {

    if (typeof html2canvas === "undefined") {
      alert("Export library failed to load.");
      return;
    }

    try {

      const canvas = await html2canvas(els.preview, {
        scale: 2,
        allowTaint: true,
        backgroundColor: null,
        logging: false
      });

      const link = document.createElement("a");

      link.download = "my-design.png";

      link.href = canvas.toDataURL("image/png");

      document.body.appendChild(link);

      link.click();

      document.body.removeChild(link);

    } catch (err) {

      console.error("Export failed:", err);

      alert("Could not export design.");
    }
  });
}
/* =========================
   TEXT LAYER SELECTION
========================= */

window.activeTextLayer = null;

function selectTextLayer(el) {

  document.querySelectorAll('.draggable-text[data-extra="true"]').forEach(t => {
    t.classList.remove("selected-text");
  });

  window.activeTextLayer = el;

  if (window.activeTextLayer) {
  window.activeTextLayer.classList.add("selected-text");
}
}

/* CLICK TO SELECT TEXT */

if (els.preview) {
  els.preview.addEventListener("click", function(e) {

  if (e.target.classList.contains("draggable-text")) {

    selectTextLayer(e.target);

  } else {

    document.querySelectorAll('.draggable-text[data-extra="true"]').forEach(t => {
      t.classList.remove("selected-text");
    });

    window.activeTextLayer = null;
  }
});
}


    

    
    


    
  if (els.baseWoodImage) {

  els.baseWoodImage.style.borderRadius = "0";
  els.baseWoodImage.style.borderTopLeftRadius = "0";
  els.baseWoodImage.style.borderTopRightRadius = "0";
  els.baseWoodImage.style.borderBottomLeftRadius = "0";
  els.baseWoodImage.style.borderBottomRightRadius = "0";

}
    

    
    function updateShape() {

  if (!els.shapeSelector || !els.preview) return;

  const baseImage = els.baseWoodImage;

  if (!baseImage) return;

  baseImage.style.filter = "";
  baseImage.style.objectFit = "cover";
  baseImage.style.borderRadius = "0";

  const shape = els.shapeSelector.value;

  let newSrc = "";
  

  /* RESET EVERYTHING */

  els.preview.style.borderRadius = "0";
  els.preview.style.clipPath = "none";

  baseImage.style.borderRadius = "";
baseImage.style.borderTopLeftRadius = "";
baseImage.style.borderTopRightRadius = "";
baseImage.style.borderBottomLeftRadius = "";
baseImage.style.borderBottomRightRadius = "";
baseImage.style.clipPath = "";
baseImage.style.webkitClipPath = "";

  /* ROUND */

  if (shape === "round") {

    newSrc =
      "https://cdn.shopify.com/s/files/1/0697/1978/5705/files/sannarita-signature-round.png?v=1776178451";

    baseImage.style.clipPath =
  "circle(50% at 50% 50%)";
  }

  /* RECTANGLE */

  if (shape === "rectangle") {

    newSrc =
      "https://cdn.shopify.com/s/files/1/0697/1978/5705/files/sannarita-signature-rectangle.png?v=1776184545";
  }

  /* ARCH */

  if (shape === "arch") {

  newSrc =
    "https://cdn.shopify.com/s/files/1/0697/1978/5705/files/sannarita-signature-Arch.png?v=1776177899";

  baseImage.style.clipPath = "none";

  baseImage.style.borderTopLeftRadius = "300px";
  baseImage.style.borderTopRightRadius = "300px";

  baseImage.style.borderBottomLeftRadius = "0";
  baseImage.style.borderBottomRightRadius = "0";
  baseImage.style.objectFit = "cover";
}


  if (newSrc) {
    baseImage.src = newSrc;
  }
  /* RE-ENABLE IMAGE DRAG */

if (
  els.imageWrapper &&
  els.imageWrapper.style.display !== "none" &&
  window.WOOD_DRAG?.enable
) {

  window.WOOD_DRAG.enable(
    els.imageWrapper,
    els.preview
  );

  els.imageWrapper.dataset.dragEnabled = "true";
}
  baseImage.style.position = "relative";
baseImage.style.zIndex = "1";

  updateStain();
  window.WOODPricing?.updateLiveSummary();
}



if (els.shapeSelector) {

  if (typeof syncShapeCards === "function") {
    syncShapeCards();
  }

}
if (els.shapeSelector) {

  els.shapeSelector.addEventListener(
    "change",
    function () {

      updateShape();

      window.WOODPricing?.updatePrice?.();

      debouncedSave();

    }
  );

}
function updateStain() {

  const img = els.baseWoodImage;

  if (!img) return;

  const stain =
    els.stainSelector?.value || "none";

  switch (stain) {

    case "espresso":

      img.style.filter =
        "brightness(0.72) sepia(0.55) saturate(1.2)";

      break;

    case "grey":

      img.style.filter =
        "grayscale(0.9) brightness(0.9)";

      break;

    case "black":

      img.style.filter =
        "brightness(0.45) contrast(1.1)";

      break;

    default:

      img.style.filter = "none";
  }
}

/* =========================
   TEXT STYLE
========================= */

function updateTextStyle() {

  const allText =
  document.querySelectorAll(".draggable-text");

  allText.forEach(el => {

    el.classList.remove(
      "text-flat",
      "text-raised"
    );

    if (els.textStyle?.value === "flat") {
      el.classList.add("text-flat");
    }

    if (els.textStyle?.value === "raised") {
      el.classList.add("text-raised");
    }

  });
}
window.updateShape = updateShape;
window.updateStain = updateStain;
window.updateTextStyle = updateTextStyle;

    

    


/* =========================
   IMAGE COLOR DETECTION
========================= */

function getImageColorCount(img) {

  try {

    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    const width = 80;
    const height = 80;

    canvas.width = width;
    canvas.height = height;

    ctx.drawImage(img, 0, 0, width, height);

    const imageData =
      ctx.getImageData(0, 0, width, height).data;

    const colors = new Set();

    for (let i = 0; i < imageData.length; i += 16) {

      const r =
        Math.round(imageData[i] / 32) * 32;

      const g =
        Math.round(imageData[i + 1] / 32) * 32;

      const b =
        Math.round(imageData[i + 2] / 32) * 32;

      const a = imageData[i + 3];

      /* IGNORE TRANSPARENT PIXELS */

      if (a < 40) continue;

      colors.add(`${r},${g},${b}`);
    }

    return colors.size;

  } catch (err) {

    console.error(
      "Color detection failed",
      err
    );

    return 0;
  }
}



/* =========================
   COLOR UI
========================= */

function updateColorUI() {

  const count =
    WOOD_STATE.cachedColorCount || 0;

  const tier =
  window.WOODPricing?.getLogoTier(count) || "simple";

  if (els.colorCountText) {
    els.colorCountText.textContent =
      count + " colors detected";
  }

  if (els.colorComplexityText) {
    els.colorComplexityText.textContent =
      tier;
  }

  if (els.scaleFill) {

    let percent = 0;

    if (tier === "simple") {
      percent = 30;
    }

    if (tier === "moderate") {
      percent = 65;
    }

    if (tier === "complex") {
      percent = 100;
    }

    els.scaleFill.style.width =
      percent + "%";
  }

  if (els.colorSuggestion) {

    if (tier === "simple") {
      els.colorSuggestion.textContent =
        "Great for clean engraving.";
    }

    if (tier === "moderate") {
      els.colorSuggestion.textContent =
        "Moderate detail detected.";
    }

    if (tier === "complex") {
      els.colorSuggestion.textContent =
        "Highly detailed logo detected.";
    }
  }
}

/* =========================
   COLOR PALETTE
========================= */

function renderColorPalette(img) {

  if (!els.colorPalette) return;

  els.colorPalette.innerHTML = "";

  try {

    const canvas =
      document.createElement("canvas");

    const ctx =
      canvas.getContext("2d");

    const width = 50;
    const height = 50;

    canvas.width = width;
    canvas.height = height;

    ctx.drawImage(img, 0, 0, width, height);

    const data =
      ctx.getImageData(0, 0, width, height).data;

    const colorMap = {};

    for (let i = 0; i < data.length; i += 16) {

      const r =
        Math.round(data[i] / 32) * 32;

      const g =
        Math.round(data[i + 1] / 32) * 32;

      const b =
        Math.round(data[i + 2] / 32) * 32;

      const a = data[i + 3];

      if (a < 40) continue;

      const key = `${r},${g},${b}`;

      colorMap[key] =
        (colorMap[key] || 0) + 1;
    }

    const sortedColors =
      Object.entries(colorMap)
      .sort((a, b) => b[1] - a[1])
      .slice(0, 8);

    sortedColors.forEach(([rgb]) => {

      const swatch =
        document.createElement("div");

      swatch.style.width = "24px";
      swatch.style.height = "24px";
      swatch.style.borderRadius = "50%";
      swatch.style.background =
        `rgb(${rgb})`;

      swatch.style.border =
        "1px solid #ccc";

      els.colorPalette.appendChild(swatch);
    });

  } catch (err) {

    console.error(
      "Palette render failed",
      err
    );
  }
}

  


   
function isValidVariant(id) {
  return !isNaN(Number(id)) && Number(id) > 0;
}
console.log("REACHED ADD TO CART SECTION");

async function uploadDesign(blob, builderId) {

  if (!window.supabaseClient) {
    throw new Error(
      "Supabase not initialized"
    );
  }

  const supabase =
    window.supabaseClient;

  console.log(
    "Uploading design:",
    builderId
  );

  const filename =
    `${builderId}.png`;

  const { data, error } =
    await supabase.storage
      .from("designs")
      .upload(filename, blob, {
        contentType: "image/png",
        upsert: true
      });

  console.log(
    "UPLOAD DATA:",
    data
  );

  console.log(
    "UPLOAD ERROR:",
    error
  );

  if (error) {
    console.error(error);
    throw error;
  }

  const { data: publicUrlData } =
    supabase.storage
      .from("designs")
      .getPublicUrl(filename);

  console.log(
    "PUBLIC URL:",
    publicUrlData.publicUrl
  );

  return publicUrlData.publicUrl;
}
/* =========================
   FORM SUBMIT
========================= */

const addBtn =
  document.getElementById("addToCartBtn");

if (addBtn) {
addBtn.addEventListener("click", async function (e) {

  e.preventDefault();
  e.stopImmediatePropagation();
  if (!els.textInput?.value.trim()) {

  if (els.builderError) {
  els.builderError.style.display = "block";
}

  els.builderError.textContent =
    "Please enter your custom text.";

  return;
}

els.builderError.style.display = "none";

  window.WOODPricing?.updateCartProperties();

    const builderId =
  Date.now().toString(36) +
  Math.random().toString(36).slice(2);

    const items = [];
    const shape =
  (els.shapeSelector?.value || "")
    .trim()
    .toLowerCase();

if (!shape) {
  console.error("Shape missing");
  return;
}

const wood =
  (els.woodType?.value || "birch")
    .trim()
    .toLowerCase();

const size =
  (els.sizeSelector?.value || "24x24")
    .trim();


const shapeData =
  window.WOOD_VARIANTS.getBaseVariant(shape, wood, size);
console.log("Shape:", shape);
console.log("Wood:", wood);
console.log("Size:", size);
console.log(
  "Variant lookup:",
  window.WOOD_VARIANTS.getBaseVariant(
    shape,
    wood,
    size
  )
);  
if (!shapeData) {
  alert("Invalid variant selection");
  addBtn.dataset.loading = "false";
  return;
}
let designExport;

try {

  designExport = await html2canvas(
    els.preview,
    {
      backgroundColor: null,
      useCORS: true,
      logging: false,
      removeContainer: true
    }
  );

} catch(error) {

  console.error(
    "HTML2CANVAS FAILED",
    error
  );

  alert(
    "Could not generate preview image."
  );

  addBtn.dataset.loading = "false";

  return;
}

const blob = await new Promise(resolve =>
  designExport.toBlob(resolve, "image/png")
);
console.log("BLOB:", blob);
console.log("BLOB SIZE:", blob?.size);
const previewUrl =
  await uploadDesign(
    blob,
    builderId
  );

console.log(
  "Preview URL:",
  previewUrl
);
console.log(blob);

items.push({
  id: shapeData.variantId,
  quantity: 1,
  properties: {
    "_builderId": builderId,
    "Preview Image": previewUrl,
    "Custom Text": els.textInput?.value || "",
    "Text Style": els.textStyle?.value || "",
    "Size": size,
    "Shape": shape,
    "Wood Type": wood,
    "Layers": els.layerSelector?.value || "",
    "Stain": els.stainSelector?.value || "",
    "Rush Order": els.rushOrder?.value || ""
  }
});
const layers =
  parseInt(els.layerSelector?.value || 1);
/* =========================
   ADD LAYER VARIANTS
========================= */
if (layers > 1) {

  const layerVariant =
    window.WOOD_VARIANTS.getFeeVariant(`layer${layers}`);

  if (layerVariant?.variantId) {

    items.push({
      id: layerVariant.variantId,
      quantity: 1,
      properties: {
        "_builderId": builderId,
        "_addon": `${layers} Layer Upgrade`
      }
    });

  }

}


/* =========================
   STAIN VARIANTS
========================= */
function capitalize(str) {

  if (!str) return "";

  return str.charAt(0).toUpperCase() +
    str.slice(1);

}
const stainKey =
  `stain${capitalize(
    els.stainSelector?.value
  )}`;

const stainVariant =
  window.WOOD_VARIANTS.getFeeVariant(stainKey);
if (stainVariant?.variantId) {

  items.push({
    id: stainVariant.variantId,
    quantity: 1,
    properties: {
      "_builderId": builderId,
      "_addon": "Stain Upgrade"
    }
  });

}



/* =========================
   TEXT STYLE
========================= */
let totalText = "";

if (els.textInput?.value) {
  totalText += els.textInput.value;
}

document.querySelectorAll(".draggable-text[data-extra='true']:not(#liveTextPreview)").forEach(el => {
  totalText += (el.textContent || "").trim();
});
const textVariant =
  window.WOOD_VARIANTS.getTextStyleVariant(
    els.textStyle?.value,
    WOOD_STATE.currentTextTier
  );

if (totalText.trim()) {

  
  if (textVariant?.variantId) {

    items.push({
      id: textVariant.variantId,
      quantity: 1,
      properties: {
        "_builderId": builderId,
        "_addon": "Text Style"
      }
    });

  }

}
/* =========================
   PAINT COLOR
========================= */

const activeSwatch =
  document.querySelector(".color-swatch.active");

if (activeSwatch) {

  const color =
    activeSwatch.dataset.color;

  const paintMap = {
  "#000000": "blackPaint",
  "#ffffff": "whitePaint",
  "#c19a6b": "goldPaint"
};

const paintKey = paintMap[color];

const paintVariant =
  window.WOOD_VARIANTS.getFeeVariant(paintKey); 
if (paintVariant?.variantId) {

  items.push({
    id: paintVariant.variantId,
    quantity: 1,
    properties: {
      "_builderId": builderId,
      "_addon": "Paint Upgrade"
    }
  });

}
}
/* =========================
   HAND DETAIL
========================= */

if (els.detailToggle?.checked) {

  const handDetailVariant =
    window.WOOD_VARIANTS.getFeeVariant("handDetail");

  if (handDetailVariant?.variantId) {

    items.push({
      id: handDetailVariant.variantId,
      quantity: 1,
      properties: {
        "_builderId": builderId,
        "_addon": "Hand Detail"
      }
    });

  }

}

const logoTier =
  window.WOODPricing?.getLogoTier(
    WOOD_STATE.cachedColorCount
  ) || "simple";
const logoVariant =
  window.WOOD_VARIANTS.getLogoComplexityVariant(
    logoTier
  );
if (
  els.liveImage?.src &&
  els.liveImage?.src?.includes("data:")
) {

  
  if (logoVariant?.variantId) {

    items.push({
      id: logoVariant.variantId,
      quantity: 1,
      properties: {
        "_builderId": builderId,
        "_addon": "Logo Complexity"
      }
    });

  }
}

/* =========================
   RUSH ORDER
========================= */

if (
  els.rushOrder?.value === "priority" ||
  els.rushOrder?.value === "express"
) {

  const rushVariant =
    window.WOOD_VARIANTS.getFeeVariant("rushOrder");

  if (rushVariant?.variantId) {

    items.push({
      id: rushVariant.variantId,
      quantity: 1,
      properties: {
        "_builderId": builderId,
        "_addon": "Rush Order"
      }
    });

  }

}
    

    

    /* =========================
       SUBMIT TO SHOPIFY
    ========================= */
    if (addBtn.dataset.loading === "true") {
  return;
}



addBtn.dataset.loading = "true";

    try {

      const submitBtn =
        document.getElementById("addToCartBtn");

      if (submitBtn) {

        submitBtn.disabled = true;

        submitBtn.innerText =
          "Adding...";
      }

      console.log(
        "Submitting items:",
        items
      );

      console.log(
  JSON.stringify(items, null, 2)
);
items.forEach(item => {

  if (!isValidVariant(item.id)) {

    console.warn(
      "Missing variant:",
      item
    );

  }

});

const cleanItems = items.filter(item =>
  item &&
  !isNaN(Number(item.id)) &&
  Number(item.id) > 0
);

if (!cleanItems.length) {

  alert("Invalid configuration.");

  addBtn.dataset.loading = "false";

  return;
}



const finalItems = [...cleanItems];

console.log(
  "Submitting clean items:",
  finalItems
);
      const response = await fetch(
        "/cart/add.js",
        {

          method: "POST",

          headers: {
            "Content-Type": "application/json"
          },

          body: JSON.stringify({
  items: finalItems
})
        }
      );

      if (!response.ok) {

        const errorData =
          await response.json();

        console.error(
          "Cart Error:",
          errorData
        );

        throw new Error(
          errorData.description ||
          "Cart failed"
        );
      }

      

      /* =========================
         AJAX CART OPEN
      ========================= */

document.dispatchEvent(
  new CustomEvent("cart:refresh")
);

document.dispatchEvent(
  new CustomEvent("cart:open")
);

/* SUCCESS BUTTON */

if (submitBtn) {

  submitBtn.disabled = false;

  submitBtn.innerText = "Added ✓";

setTimeout(() => {
  submitBtn.innerText = "Add to Cart";
}, 2000);
}
addBtn.dataset.loading = "false";

    } catch (err) {

      console.error(
        "ADD TO CART FAILED:",
        err
      );

      alert(
        "Could not add item to cart."
      );
      addBtn.dataset.loading = "false";

      const submitBtn =
        document.getElementById("addToCartBtn");

      if (submitBtn) {

        submitBtn.disabled = false;

        submitBtn.innerText =
          "Add to Cart";
      }
    }
  });
}

async function getCart() {

  const response =
    await fetch("/cart.js");

  return await response.json();
}
async function syncBuilderQuantities(
  builderId,
  quantity
) {

  const cart = await getCart();

  const updates = {};

  cart.items.forEach(item => {

    if (
      item.properties &&
      item.properties._builderId === builderId
    ) {

      updates[item.key] = quantity;
    }
  });

  await fetch("/cart/update.js", {

    method: "POST",

    headers: {
      "Content-Type": "application/json"
    },

    body: JSON.stringify({
      updates
    })
  });

  document.dispatchEvent(
    new CustomEvent("cart:refresh")
  );
}



    /* =========================
       DELETE IMAGE
    ========================= */

    if (els.deleteBtn) {

      els.deleteBtn.addEventListener("click", function () {

        els.liveImage.src = "";
        WOOD_STATE.cachedColorCount = 0;

if (els.colorPalette) {
  els.colorPalette.innerHTML = "";
}

        els.imageWrapper.style.display = "none";
        els.liveImage.style.display = "none";

        updateColorUI();
        window.WOODPricing?.updatePrice();

        

        debouncedSave();
      });
    }
    /* =========================
   DELETE TEXT LAYER
========================= */

document.addEventListener("keydown", function(e) {

  if (
  (e.key === "Delete" || e.key === "Backspace") &&
  window.activeTextLayer
) {

    /* Prevent deleting while typing */
    if (window.activeTextLayer?.contentEditable === "true") {
      return;
    }

    if (window.activeTextLayer?.remove) {
  window.activeTextLayer.remove();
}

window.activeTextLayer = null;

    

    debouncedSave();
  }
});

   



    const addonItems = document.querySelectorAll(".addon-item");

if (addonItems.length) {

  addonItems.forEach(item => {

    item.addEventListener("change", function () {

      updateTextStyle();
      
      debouncedSave();

    });

  });

}

    /* =========================
   INIT
========================= */

window.WOODStorage?.load();
if (window.WOODPricing?.init) {
  window.WOODPricing.init();
}
updateShape();

updateTextStyle();

updateColorUI();
window.WOODPricing?.updateLiveSummary();


 } // CLOSE initCustomizer()

if (!window.__WOOD_CUSTOMIZER_INIT__) {

  window.__WOOD_CUSTOMIZER_INIT__ = true;

  if (document.readyState === "loading") {

    document.addEventListener(
      "DOMContentLoaded",
      initCustomizer
    );

  } else {

    initCustomizer();

  }
}


